import { ButtonProps, IconButton, useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { TagModal } from 'apps/TenantApp/components/tags/TagModal';
import { HasTagsIcon, TagIcon } from 'components/icons';
import React from 'react';
import { graphql, useFragment } from 'utils/graphClient';
import { useFeatureFlag } from 'utils/sessionProvider';
import { TagButton_node$key } from './__generated__/TagButton_node.graphql';

const nodeFragment = graphql`
  fragment TagButton_node on Node {
    __typename
    id
    ... on HasTagsInterface {
      tags {
        id
      }
      canUpdateTags {
        value
      }
    }
  }
`;

interface TagButtonProps extends ButtonProps {
  node: TagButton_node$key;
}

export const TagButton = ({ node, ...buttonProps }: TagButtonProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { __typename, id, tags, canUpdateTags } = useFragment(
    nodeFragment,
    node,
  );

  const isRenameTagsEnabled = useFeatureFlag('FEATURE_RENAME_TAGS_TO_LABELS');

  const ariaLabel = isRenameTagsEnabled
    ? canUpdateTags?.value
      ? t`Edit labels`
      : t`See labels`
    : canUpdateTags?.value
    ? t`Edit tags`
    : t`See tags`;

  const hasTags = !!tags?.length;

  const showTagButton = __typename !== 'Vault';
  if (!showTagButton) {
    return null;
  }

  return (
    <>
      <IconButton
        aria-label={ariaLabel}
        icon={hasTags ? <HasTagsIcon /> : <TagIcon />}
        onClick={onOpen}
        colorScheme={hasTags ? 'blue' : 'gray'}
        size="sm"
        variant="ghost"
        {...buttonProps}
      />
      <TagModal nodeId={id} isOpen={isOpen} onClose={onClose} />
    </>
  );
};
